/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({

  postsRequest: ["post"],
  postsSuccess: ["response"],
  postsFailure: null,
  postsItemRequest: ["post"],

  postsItemSuccess: ["response"],

  postsItemFailure: null,
  postsLikeRequest: ["post"],
  postsLikeSuccess: ["response"],
  postsLikeFailure: null,
  postsTagRequest: ["post"],
  postsTagSuccess: ["response"],
  postsTagFailure: null,
  readPostRequest: ["post"],
  readPostSuccess: ["response"],
  readPostFailure: null,
  postTagDetailRequest: ["post"],
  postTagDetailSuccess: ["response"],
  postTagDetailFailure: null,

  getPostAllLikesRequest: ["postId"],
  getPostAllLikesSuccess: ["response"],
  getPostAllLikesFailure: null,

  getPostCommentsRequest: ["params"],
  getPostCommentsSuccess: ["response"],
  getPostCommentsFailure: null,

  postCommentRequest: ["params"],
  postCommentSuccess: ["response"],
  postCommentFailure: null,

  deleteCommentRequest: ["params"],
  deleteCommentSuccess: ["timestamp"],
  deleteCommentFailure: null,

  searchUserRequest: ["params"],
  searchUserSuccess: ["response"],
  searchUserFailure: null,

  sendOneFrame: ['fileurl', 'videourl', 'thumburl', 'tileurl'],  // local file:// jpg url indiv rendered frame, and local file:// video url final rendered video

  checkVideoRenderResults: ['result'],

  createStandardPostRequest: ['post', 'files', 'emitter'], // last arg is to catch progress, obj type = TinyEmitter
  createStandardPostSuccess: ['response'],
  createStandardPostFailure: null,
  createStandardPostProgress: ['value'],

  listPostFilesRequest: ['params'],
  listPostFilesSuccess: ['response'],
  listPostFilesFailure: null,
  updatePostRequest: ["post"],
  updatePostSuccess: ["response"],
  updatePostFailure: null,
  repostRequest: ["post"],
  repostSuccess: ["response"],
  repostFailure: null,

  readMultiPostRequest: ["data"],
  readMultiPostSuccess: ["response"],
  readMultiPostFailure: null,
  deletePostRequest: ["data"],
  deletePostSuccess: ["response"],
  deletePostFailure: null,
  reportPostRequest: ["data"],
  reportPostSuccess: ["response"],
  reportPostFailure: null,
  deleteHashTagRequest: ["data"],
  deleteHashTagSuccess: ["response"],
  deleteHashTagFailure: null,
})

export const PostsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  // username: null,
  userId: null,
  posts: null,
  token: null,
  fetching: null,
  error: null,
  pagination: '',
  readPost: null,
  postTagDetail: null,
	allLikes: null,
	commentsUpdated: 0,
	commentsPostId: null,
	commentsLoading: false,
  comments: null,
  sending: false,
  sendCommentSuccess: false,
  mentionUsers: null,
  updatePost: null,
  respost: null,
  //create post and
  updating: false,
  newPost: null,
  newPostMeta: null,
  updatePostSuccess: null,
  updatePostWasNew: null,
  updatePostProgress: 0,
  readMutiPost: null,
  postdetailsModifed : null,
  deletePost: null,
  reportPost : null,
  oneRenderedFrame : null,
  finalRenderedVideo : null,
  thumburl : null,
  tileurl : null,
  deleteHashTag : null
})

/* ------------- Reducers ------------- */

// request posts
export const request = (state, action) => {
  const { userId, start } = action
  console.tron.display({
    name: 'PostsRedux request',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, userId, posts: null, pagination: start })
}
export const deleteHashTagRequest = (state, action) => {

  return state.merge({ fetching: true })
}
export const reportPostRequest = (state, action) => {


  return state.merge({ fetching: true, reportPost: null })
}
export const deletePostRequest = (state, action) => {
  const { userId, start } = action
  console.tron.display({
    name: 'deletePostRequest ',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, deletePost: null })
}
export const deletePostSuccess = (state, action) => {
  const postId = action.response
  console.tron.display({
    name: 'delete post sucess',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, deletePost: postId })
}
export const deleteHashTagSuccess = (state, action) => {
  const { response: { data: { data } } } = action
  console.tron.display({
    name: 'delete hastag sucess',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: false, deleteHashTag: data })
}
export const reportPostSuccess = (state, action) => {
  const { response: { data: { data } } } = action
  console.tron.display({
    name: 'report post sucess',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, reportPost: data })
}
export const readMultiPostRequest = (state, action) => {

  console.tron.display({
    name: 'readMultiPostRequest request',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, readMutiPost: null, postdetailsModifed: null })
}
export const updatePostRequest = (state, action) => {
  const { post } = action
  console.tron.display({
    name: 'updatePostRequest request',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, updatePost: null })
}
export const readPostRequest = (state, action) => {
  const { userId, start } = action

  return state.merge({ fetching: true, userId, readPost: null, pagination: start })
}
export const repostRequest = (state, action) => {


  return state.merge({ fetching: true, repost: null })
}
export const postTagDetailRequest = (state, action) => {


  return state.merge({ fetching: true, postTagDetail: null })
}
export const postsLikeRequest = (state, action) => {
  const { userId, start } = action
  console.tron.display({
    name: 'PostsRedux request',
    preview: 'You should totally expand this',
    value: {
      action: action,

    }
  })
  return state.merge({ fetching: true, userId, posts: null, pagination: start })
}

// successful posts
export const success = (state, action) => {
  const { response } = action
  const { data } = response
  const apiResponse = data
  const { pagination: { next = '' } } = apiResponse
  return state.merge({
    fetching: false, error: null,
    posts: state.pagination != undefined && state.pagination !== next ?
      [...state.posts, ...apiResponse.data] : apiResponse.data,
    pagination: next
  })
}

export const readMultiPostSuccess = (state, action) => {
  const { response: { data: { data } } } = action
  return state.merge({
    fetching: false, error: null,
    readMuliPost: data, postdetailsModifed: new Date()
  })
}

export const updatePostSuccess = (state, action) => {
  const { response } = action

  const { data: { data } } = response
  const post = data[0]
  console.tron.display({
    name: `updatePostSuccess`,
    preview: ``,
    value: {
      state: response
    }
  })
  let changes = {
    fetching: false, error: null, updatePost: post, updatePostSuccess: Date.now(), updatePostWasNew: false
  }
  // LiveBroadcastStream uses both ReadPost and the update post, make it easier by making them the same when updating - adding new My Shop ISell tag
  if (state.readPost && state.readPost.PostId == post.PostId) {
    console.log(`updatePostSuccess, readPost is the same, updating`)
    changes = Object.assign({}, changes, {readPost: post})
  }
  return state.merge(changes)
}

export const repostSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response
  console.tron.display({
    name: `repostSuccess`,
    preview: ``,
    value: {
      state: response
    }
  })
  return state.merge({
    fetching: false, error: null, repost: data[0], updatePostSuccess: Date.now(), updatePostWasNew: true
  })
}
export const readPostSuccess = (state, action) => {
  const { response } = action

  const { data: { data } } = response
  console.tron.display({
    name: `readPostSuccess`,
    preview: ``,
    value: {
      state: response
    }
  })



  return state.merge({
    fetching: false, error: null,
    readPost: data[0],

  })
}
export const postTagDetailSuccess = (state, action) => {
  const { response } = action

  const { data: { data } } = response
  console.tron.display({
    name: `postTagDetailSuccess`,
    preview: ``,
    value: {
      state: response
    }
  })



  return state.merge({
    fetching: false, error: null,
    postTagDetail: data,

  })
}

export const postsItemSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response



  return state.merge({
    fetching: false, error: null,
    posts: state.posts != null ? [...state.posts, ...data] : data,
    post: data
  })
}
export const postsLikeSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response


  console.tron.display({
    name: `postsLikeSuccess`,
    preview: ``,
    value: {
      state: data
    }
  })



  return state.merge({
    fetching: false, error: null,
    posts: state.posts != null ? [...state.posts, ...data] : data
  })
}
export const postsTagSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response


  console.tron.display({
    name: `postsTagSuccess`,
    preview: ``,
    value: {
      state: data
    }
  })



  return state.merge({
    fetching: false, error: null,
    posts: state.posts != null ? [...state.posts, ...data] : data
  })
}

//all likes
export const getPostAllLikesSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response
  return state.merge({ fetching: false, error: null, allLikes: data })
}

//comments
export const getPostCommentsRequest = (state, action) => {
	const { params: { postId, start = '', limit = 100 } } = action
	return state.merge({ comments: null, commentsPostId: postId, commentsLoading: true })
}

export const getPostCommentsSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response

	return state.merge({ fetching: false, error: null, commentsLoading: false, commentsUpdated: Date.now(), comments: data ? data.reverse() : null })
	// *********** Maybe use updatePost and tack on all the comments?? BUT api call does not return post or userLikesPost ***********
}


//send comment
export const postCommentRequest = state => state.merge({ sending: true, sendCommentSuccess: false })
export const postCommentSuccess = (state, action) => {
	const { response } = action
  const { data: { data } } = response
	const post = response.data.meta.Post
	console.tron.display({name: 'postCommentSuccess', preview: 'post', value: post})
  return state.merge({
    sending: false,
    sendCommentSuccess: true,
		comments: state.comments != null ? [...state.comments, ...data] : data,
		// new, borrowing from update post...
    fetching: false, error: null, updatePost: Object.assign({}, post), updatePostSuccess: Date.now(), updatePostWasNew: false
	})
}

//delete comment
export const deleteCommentSuccess = (state, action) => {
  const { timestamp } = action
  const comments = state.comments.filter(item => item.TimeStamp !== timestamp)
  return state.merge({
    comments: comments
  })
}

//search user
export const searchUserSuccess = (state, action) => {
  const { response } = action
  const { data: { data } } = response
  return state.merge({
    mentionUsers: data
  })
}

export const checkVideoRenderResults = (state, action) => {

  //console.log("in posts redux, action = " + JSON.stringify(action))

  //console.log("in posts redux, state.finalRenderedVideo = " + state.finalRenderedVideo)
  //console.log("in posts redux, state.thumburl           = " + state.thumburl)
  //console.log("in posts redux, state.tileurl            = " + state.tileurl)

  action.result.finalRenderedVideo = state.finalRenderedVideo
  action.result.thumburl = state.thumburl
  action.result.tileurl = state.tileurl

  //console.log("in posts redux, action modfied = " + JSON.stringify(action))

  return state
}

// action is the file:// url of rendered frame
// model after createStandardPostProgress
export const sendOneFrame = (state, action) => {
  const { fileurl } = action
  const { videourl } = action
  const { thumburl } = action
  const { tileurl } = action
  // the final 2 are needed to post video but are not displayed on tagging page
  var obj = {}
  if (fileurl) obj['oneRenderedFrame'] = fileurl
  if (videourl) obj['finalRenderedVideo'] = videourl
  if (thumburl) obj['thumburl'] = thumburl
  if (tileurl) obj['tileurl'] = tileurl
  // filenumber but we dont know max offhand
  if (fileurl) {
    var fnum = fileurl.replace(/^.*_/, '')
    if (fnum) {
      fnum = fnum.replace(/.jpg$/, '')
      // so just div by 1000
      // change to 60 * 60 (60 fps 60 seconds) to avoid repeated blue bar during vid render
      var perc = fnum / 3600
      if (perc > 1) perc = perc - parseInt(perc)
      // obj['updatePostProgress'] = perc
    }
  }
  // special case for re-init, if all are clear, just clear them all
  if (!fileurl && !videourl && !thumburl && !tileurl) obj = {oneRenderedFrame : false, finalRenderedVideo : false, thumburl : false, tileurl : false}
  return state.merge(obj)
}

//Creat new post
export const createStandardPostRequest = state =>
  state.merge({ error: null, newPost: null, newPostMeta: null, updating: true, updatePostProgress: 0 })

export const createStandardPostSuccess = (state, action) => {
  // const { post } = action
  const { response } = action
  const apiResponse = response.data
  const { data, meta = null } = apiResponse
  const post = data[0]
  const posts = state.posts != null ? [...data, ...state.posts] : data
  console.tron.display({
    name: `createStandardPostSuccess`,
    preview: ``,
    value: {
      apiResponse,
      post,
      meta,
      state: posts
    }
  })
  return state.merge({ updating: false, error: null, newPost: post, newPostMeta: meta, updatePostSuccess: Date.now(), updatePostWasNew: true, updatePostProgress: 1 })
}

export const createStandardPostProgress = (state, action) => {
  const { value } = action
  if (value > state.updatePostProgress || value == 0)
    return state.merge({ updatePostProgress: value })
  else
    return state
}

// failed to fetch posts

export const failure = state => state.merge({ fetching: false, error: true, posts: null, pagination: null })
export const deleteHashTagFailure = state => state.merge({ fetching: false, deleteHashTag: null})
export const reportPostFailure = state => state.merge({ fetching: false, error: true, reportPost: null})
export const deletePostFailure = state => state.merge({ fetching: false, error: true, deletePost: null, pagination: null })
export const readMultiPostFailure = state => state.merge({ fetching: false, error: true, readMultiPost: null, pagination: null })
export const repostFailure = state => state.merge({ fetching: false, error: true, repost: null, pagination: null })
export const updatePostFailure = state => state.merge({ fetching: false, error: true, updatePost: null, pagination: null })
export const postsItemFailure = state => state.merge({ fetching: false, error: true, posts: null, pagination: null })
export const postsLikeFailure = state => state.merge({ fetching: false, error: true, posts: null, pagination: null })
export const postsTagFailure = state => state.merge({ fetching: false, error: true, posts: null, pagination: null })
export const readPostFailure = state => state.merge({ fetching: false, error: true, readPost: null })
export const postTagDetailFailure = state => state.merge({ fetching: false, error: true, postTagDetail: null })
export const getPostAllLikesFailure = state => state.merge({ fetching: false, error: true, allLikes: null })
export const getPostCommentsFailure = state => state.merge({ fetching: false, error: true, comments: null })
export const postCommentFailure = state => state.merge({ sending: false, sendCommentSuccess: false })
export const searchUserFailure = state => state.merge({ mentionUsers: null })
export const deleteCommentFailure = state => state
export const createStandardPostFailure = state => state.merge({ error: true, updating: false, updatePostProgress: 0 })

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.POSTS_REQUEST]: request,
  [Types.POSTS_SUCCESS]: success,
  [Types.POSTS_FAILURE]: failure,
  [Types.POSTS_ITEM_REQUEST]: request,
  [Types.POSTS_ITEM_SUCCESS]: postsItemSuccess,
  [Types.POSTS_ITEM_FAILURE]: postsItemFailure,
  [Types.POSTS_LIKE_REQUEST]: postsLikeRequest,
  [Types.POSTS_LIKE_SUCCESS]: postsLikeSuccess,
  [Types.POSTS_LIKE_FAILURE]: postsLikeFailure,
  [Types.POSTS_TAG_REQUEST]: request,
  [Types.POSTS_TAG_SUCCESS]: postsTagSuccess,
  [Types.POSTS_TAG_FAILURE]: postsTagFailure,
  [Types.READ_POST_REQUEST]: readPostRequest,
  [Types.READ_POST_SUCCESS]: readPostSuccess,
  [Types.READ_POST_FAILURE]: readPostFailure,
  [Types.POST_TAG_DETAIL_REQUEST]: postTagDetailRequest,
  [Types.POST_TAG_DETAIL_SUCCESS]: postTagDetailSuccess,
  [Types.POST_TAG_DETAIL_FAILURE]: postTagDetailFailure,
  [Types.GET_POST_ALL_LIKES_SUCCESS]: getPostAllLikesSuccess,
  [Types.GET_POST_ALL_LIKES_FAILURE]: getPostAllLikesFailure,

  [Types.GET_POST_COMMENTS_REQUEST]: getPostCommentsRequest,
  [Types.GET_POST_COMMENTS_SUCCESS]: getPostCommentsSuccess,
  [Types.GET_POST_COMMENTS_FAILURE]: getPostCommentsFailure,

  [Types.POST_COMMENT_REQUEST]: postCommentRequest,
  [Types.POST_COMMENT_SUCCESS]: postCommentSuccess,
  [Types.POST_COMMENT_FAILURE]: postCommentFailure,

  [Types.DELETE_COMMENT_SUCCESS]: deleteCommentSuccess,
  [Types.DELETE_COMMENT_FAILURE]: deleteCommentFailure,

  [Types.SEARCH_USER_SUCCESS]: searchUserSuccess,
  [Types.SEARCH_USER_FAILURE]: searchUserFailure,

  [Types.CHECK_VIDEO_RENDER_RESULTS] : checkVideoRenderResults,

  [Types.SEND_ONE_FRAME] : sendOneFrame,

  [Types.CREATE_STANDARD_POST_REQUEST]: createStandardPostRequest,
  [Types.CREATE_STANDARD_POST_SUCCESS]: createStandardPostSuccess,
  [Types.CREATE_STANDARD_POST_FAILURE]: createStandardPostFailure,
  [Types.CREATE_STANDARD_POST_PROGRESS]: createStandardPostProgress,

  [Types.UPDATE_POST_REQUEST]: updatePostRequest,
  [Types.UPDATE_POST_SUCCESS]: updatePostSuccess,
  [Types.UPDATE_POST_FAILURE]: updatePostFailure,

  [Types.REPOST_REQUEST]: repostRequest,
  [Types.REPOST_SUCCESS]: repostSuccess,
  [Types.REPOST_FAILURE]: repostFailure,

  [Types.READ_MULTI_POST_REQUEST]: readMultiPostRequest,
  [Types.READ_MULTI_POST_SUCCESS]: readMultiPostSuccess,
  [Types.READ_MULTI_POST_FAILURE]: readMultiPostFailure,

  [Types.DELETE_POST_REQUEST]: deletePostRequest,
  [Types.DELETE_POST_SUCCESS]: deletePostSuccess,
  [Types.DELETE_POST_FAILURE]: deletePostFailure,

  [Types.REPORT_POST_REQUEST]: reportPostRequest,
  [Types.REPORT_POST_SUCCESS]: reportPostSuccess,
  [Types.REPORT_POST_FAILURE]: reportPostFailure,

  [Types.DELETE_HASH_TAG_REQUEST]: deleteHashTagRequest,
  [Types.DELETE_HASH_TAG_SUCCESS]: deleteHashTagSuccess,
  [Types.DELETE_HASH_TAG_FAILURE]: deleteHashTagFailure,

})
